import { errorConfig } from 'constants/home';

export interface IGetOTPResponse {
  commId: string;
  status: string;
  action: string;
  message: keyof typeof errorConfig;
  traceId: string;
}

export const enum KeyEvent {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
}

export const enum VerifyOTPAction {
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP',
}
export type OTPErrorMessage = keyof typeof errorConfig;
